<template>
    <gcmcn-layout
        title="ALL ENTITIES"
        custom-class="entities-view"
    >
        <el-button
            slot="action-btn"
            type="primary"
            class="gcmcn-primary-btn"
            :disabled="$store.getters.userIsManager"
            @click="onAddEntity"
        >
            Add entity
        </el-button>
        <el-row
            :gutter="26"
            class="gcmcn-separator"
        >
            <el-col
                :span="12"
                :style="{height: `calc(100vh - ${this.$store.getters.pageHeight}px)`}"
                style="overflow-y: none;"
            >

                <gcmcn-filters
                    ref="gcmcn-filters"
                    :filter-values="[selectedSortType, searchFilter]"
                    @reset-filters="resetFilters"
                    @hook:mounted="computeFilterHeight"
                >
                    <dropdown
                        name="Sort"
                        :multiple="false"
                        :list="$store.getters.sortTypeList"
                        itemName="name"
                        itemValue="value"
                        :itemsSelected="selectedSortType.length > 0 ? [selectedSortType] : []"
                        @on-select-item="selectedSortType = $event"
                    ></dropdown>
                    <search-filter ref="search" @new-value="searchFilter = $event"></search-filter>
                </gcmcn-filters>
                <div
                    style="overflow-y: scroll;padding-right: 3px;"
                    :style="{height: `calc(100vh - ( ${usedHeight}px)`}"
                >
                    <template v-if="filteredEntities.length > 0">
                        <entity
                            v-for="entity in filteredEntities"
                            :key="entity.uid"
                            :entity="entity"
                            :selected-entity-uid="selectedEntityUid"
                            @on-select-entity="onSelectEntity"
                        ></entity>
                    </template>
                    <template v-else>
                        <p class="list-empty">No entity</p>
                    </template>
                </div>
            </el-col>
            <el-col
                :span="12"
                :style="{height: `calc(100vh - ${this.$store.getters.pageHeight}px)`}"
                style="overflow-y: auto;"
            >
                <entity-form
                    v-if="displayFormView"
                    :entity="selectedEntity"
                    @leave-form-view="displayFormView = false"
                    @on-entity-created="onEntityCreated"
                >
                </entity-form>
                <entity-details
                    v-else-if="selectedEntity"
                    :selected-entity="selectedEntity"
                    @on-edit-entity="onEditEntity"
                ></entity-details>
            </el-col>
        </el-row>
    </gcmcn-layout>
</template>
<script>
import GcmcnLayout from '../../partials/gcmcn-layout.vue';
import Entity from './entity.vue';
import EntityDetails from './entity-detail.vue';
import EntityForm from './entity-form.vue';
import {
    GcmcnFilters,
    Dropdown,
    SearchFilter ,
} from 'gcmcn-common';
import {mapGetters} from 'vuex';
export default {

    components: {
        EntityForm,
        GcmcnLayout,
        EntityDetails,
        Entity,
        GcmcnFilters,
        Dropdown,
        SearchFilter ,
    },

    props: {

    },

    data (){
        return {
            selectedSortType: 'asc',
            searchFilter: '',
            selectedEntity: null,
            displayFormView: false,
            usedHeight: 0
        };
    },

    computed: {
        ...mapGetters([
            'windowWidth'
        ]),

        selectedEntityUid (){
            return this.selectedEntity ? this.selectedEntity.uid : '';
        },

        filteredEntities (){
            let entities = this.$store.getters.entities.slice();
            if(this.selectedSortType){
                entities.sort((a, b) => a.display_name.localeCompare(b.display_name));
                if(this.selectedSortType === 'dsc'){
                    entities.reverse();
                }
            }
            if(this.searchFilter){
                entities = entities.filter((u) => u.display_name.toLowerCase().includes(this.searchFilter.toLowerCase()));
            }
            return entities;
        },
    },

    watch: {
        windowWidth (){
            this.computeFilterHeight();
        },
    },
    mounted (){
        this.computeFilterHeight();
    },
    methods: {
        computeFilterHeight() {
            if(this.$refs['gcmcn-filters']){
                const clientRect = this.$refs['gcmcn-filters'].$el.getBoundingClientRect();
                this.usedHeight = clientRect.top + clientRect.height + 10 + 32; // +10 par ce que l'element contient un margin, et les margin ne sont pas comptés dans la height d'un element
                // 32 -> on enleve la height du wrapper d'alerte de fundation
            }
        },
        onSelectEntity (entity){
            if(this.displayFormView) this.displayFormView = false;
            this.$set(this, 'selectedEntity', entity);
        },
        onAddEntity (){
            this.$set(this, 'selectedEntity', null);
            this.displayFormView = true;
        },
        onEditEntity (){
            this.displayFormView = true;
        },
        resetFilters (){
            this.selectedSortType = '';
            this.$refs.search.clear();
        },
        onEntityCreated (){
            this.$store.dispatch('fetchModelByName', 'entities').then(() => {
                this.displayFormView = false;
            });
        }
    },
};
</script>

<style lang="scss">
.entities-view{
    padding-bottom: 0 !important;
    background-color: #333;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Entities/index.vue